export const HEIGHT_HEADER = 93
export const HEIGHT_HEADER_SHORT = 74

export const TYPE_GRID_LAYOUT = {
  SINGLE_COLUMN: 'SINGLE_COLUMN',
  DOUBLE_COLUMN: 'DOUBLE_COLUMN',
}

export const settingsSlider = {
  centerMode: true,
  draggable: true,
  speed: 500,
  slidesToShow: 1,
  dots: false,
  arrows: false,
  infinite: false,
  centerPadding: '48px',
}

export const foodCourtPartners = {
  aeon_mall: 'aeon_mall',
}
